import { render, staticRenderFns } from "./QuestionBox.vue?vue&type=template&id=5790349a"
import script from "./QuestionBox.vue?vue&type=script&lang=js"
export * from "./QuestionBox.vue?vue&type=script&lang=js"
import style0 from "./QuestionBox.vue?vue&type=style&index=0&id=5790349a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports